import React, { Dispatch, useState } from 'react';
import { t } from 'Locale/index';
import { LanguageSettingsContext, StyleMap } from 'types';
import { ITextTrack } from '@24i/player-base';
import { PlayerManager } from '@24i/react-native-player';
import { useLanguageSettingsContext } from 'LocalGluons/components/LanguageSettingsContext/LanguageSettingsContext';
import defaultStyles from './styles';
import { getTrackLabel } from '../GetTrackLabel';
import MediaTrackSelectBox from '../MediaTrackSelectBox/MediaTrackSelectBox';

const OFF_ITEM_ID = 'text_off';
const EMPTY_ITEM_ID = 'empty';
const EMPTY_VALUE = '--';

interface SubtitlesModalProps {
    style: StyleMap;
    onClose: () => void;
    textTracks: ITextTrack[];
    playerInstance: PlayerManager;
    setSelectedTextTrack: Dispatch<ITextTrack>;
    selectedTextTrack: ITextTrack;
}

const SubtitlesModal = ({
    style,
    onClose,
    textTracks: playerTextTracks,
    playerInstance,
    setSelectedTextTrack,
    selectedTextTrack,
}: SubtitlesModalProps) => {
    const { setSelectedPlayerTextId, getTextTrackLabel } =
        useLanguageSettingsContext() as LanguageSettingsContext;

    const parseTextTracks = (textTracks) => {
        const language = (textTrack) => {
            if (textTrack.id === OFF_ITEM_ID || textTrack.id === EMPTY_ITEM_ID) {
                return EMPTY_VALUE;
                // return t('COMMON.OFF');
            }
            return getTrackLabel(textTrack);
        };

        const tracks = textTracks || [];
        return tracks.map((textTrack) => ({
            ...textTrack,
            language: language(textTrack),
            isSelected: textTrack.selected
            // selected: false,
        }));
    };

    const parsedTextTracks = parseTextTracks(playerTextTracks);
    const [textTracks, setTextTracks] = useState([...parsedTextTracks]);

    const onSelectTextTrack = (item) => {
        const newTextTracks = textTracks.map((textTrack) => ({
            ...textTrack,
            selected: textTrack.id === item.id ?
                !!setSelectedPlayerTextId(textTrack.id) : false
        }));
        // if (item.id === selectedTextTrack.id) {
        //     return;
        // }
        // if (item.id === OFF_ITEM_ID) {
        //     setSelectedPlayerTextId(EMPTY_ITEM_ID)
        //     playerInstance.textTrack = item;
        //     setSelectedTextTrack(item);
        //     onClose();
        //     return;
        // }
        playerInstance.textTrack = item;
        setSelectedTextTrack(item);
        setTextTracks(newTextTracks);
        onClose();
    };

    const selectedTextTracks = textTracks.map((textTrack) =>
    ({
        ...textTrack, isSelected: textTrack.id === selectedTextTrack.id,
        language: getTextTrackLabel(textTrack)
    }));
    // const selectedTextTracks = textTracks.map((textTrack) => {
    // if (textTrack) {
    // if (
    //     (textTracks.length === 1 && textTrack.id === OFF_ITEM_ID) ||
    //     textTrack.id === EMPTY_ITEM_ID
    // ) {
    //     return { ...textTrack, isSelected: true };
    // }
    // if (textTrack?.id === selectedTextTrack?.id) {
    //     return { ...textTrack, isSelected: true };
    // }
    // return { ...textTrack, language: getTextTrackLabel(textTrack) };
    // }
    // return [];
    // });

    return (
        <MediaTrackSelectBox
            title={t('COMMON.SUBTITLES')}
            defaultStyles={defaultStyles}
            style={style}
            onSelectMediaTrack={onSelectTextTrack}
            selectedMediaTracks={selectedTextTracks}
            onClose={onClose}
        />
    );
};

export default SubtitlesModal;
